// extracted by mini-css-extract-plugin
module.exports = {"modalRoles":"styles_modalRoles__3iQ8m"};